export const NETLIFY_POSTFIX = 'netlify.app'
export const isApiDisabled = () => {
    return (
        // FIXME localhost instead or CLEAN
        false &&
       ( window.location.hostname.endsWith(NETLIFY_POSTFIX) ||
        process.env.REACT_APP_API_DISABLED === 'true' )
        // process.env.NODE_ENV === 'development'
    )
}
